<input type="text" maxlength="30" 
   class="date-right-panel border  bg-white rounded padding-left-5 padding-bottom-10 text-renderer"
      [ngClass]="{'border-danger red-placeholder': errDeriveName == true,'border-secondary': errDeriveName!=true}"
        value={{deriveName}} [placeholder]="errDeriveName == true ? 'Required!':''"
 [(ngModel)]="deriveName" (change)="onChange($event)">
